import {
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	Input,
	OnInit,
	Output,
} from '@angular/core';

import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { noWhitespaceValidator } from '@shared/validators/no-white-spaces.validator';
import { MatInputModule } from '@angular/material/input';

@Component({
	selector: 'cmms-simple-textarea',
	imports: [MatInputModule, ReactiveFormsModule],
	templateUrl: './cmms-simple-textarea.component.html',
	styleUrls: ['./cmms-simple-textarea.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CmmsSimpleTextareaComponent implements OnInit {
	@Input() set value(value: string) {
		this.formControl.patchValue(value);
	}
	@Input() label = '';

	@Output() controlReady = new EventEmitter<FormControl>();
	@Output() valueChange = new EventEmitter<string>();

	formControl = new FormControl('', [noWhitespaceValidator()]);

	ngOnInit() {
		this.controlReady.emit(this.formControl);
	}

	emitValue() {
		if (this.formControl.valid) {
			this.valueChange.emit(this.formControl.value);
		}
	}
}
